import { Inject } from "inversify-props";
import type { RegistroDeLiberacaoServiceAdapter } from "./adapter/RegistroDeLiberacaoServiceAdapter";
import { RegistroDeLiberacaoDTO } from "@/models";
import { AxiosRequestConfig } from "axios";

export class RegistroDeLiberacaoUseCase {
	@Inject('RegistroDeLiberacaoServiceAdapter')
	private registroDeLiberacaoServiceAdapter!: RegistroDeLiberacaoServiceAdapter

	criar = async (registroDeLiberacao: RegistroDeLiberacaoDTO, config?: AxiosRequestConfig) =>
		await this.registroDeLiberacaoServiceAdapter.criar(registroDeLiberacao, config)
}
